/**
 * Business logic per Workers autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import workersService from '../services/workersService';
import type { WorkerAutocompleteResult } from '../models/worker';
import type { BaseAutocompleteOptions, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export async function getWorkersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: BaseAutocompleteOptions = {},
): Promise<WorkerAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null } = options;

	const context: ODataContext = {
		count: true,
		select: 'id,code,name',
		expand: {
			user: {
				select: 'userName,enabled',
			},
		},
		top: 20,
		orderBy: ['user/enabled desc', 'name'],
		filter: {
			and: [],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			'tolower(name)': { contains: searchString },
		});
	} else if (id) {
		context.filter!.and!.push({
			id: { eq: id },
		});
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [
				{
					id: {
						in: notInIds,
					},
				},
			],
		});
	}

	const result = await workersService.getWorkers(buildQuery(context));
	return result.value as unknown as WorkerAutocompleteResult[];
}
